import { ILoadingMessageConstants } from "../interfaces/loading";

export const LoadingMessageConstants: ILoadingMessageConstants = {
    loadingUserName: 'Fetching Username',
    loadingAttributes: 'Fetching game properties',
    loadingConfigurations: 'Loading Configurations',
    loadingElements: 'Fetching game properties',
    loadingUserInfo: 'Fetching information of the user',
    loadingTeams: 'Getting a list of available teams',
}

export const LoadingErrorMessageConstants: ILoadingMessageConstants = {
    loadingUserName: 'lanid parameter is not present in the URL',
    loadingAttributes: 'Unable to fetch game properties',
    loadingConfigurations: 'Unable to load configurations',
    loadingElements: 'Unable to fetch game properties',
    loadingUserInfo: 'Unable to fetch information of the user',
    loadingTeams: 'Unable to fetch the list of teams',
}